import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import {
  applyBatteryConcertApplicationStatus,
  invalidateBatteryConcertApplication,
} from "./battery-concert-application-cache"
import type { BatteryConcertApplicationStatusDto } from "../dto/battery-concert-application.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

/** Send every uploaded stipulation document to Concert for underwriting review. */
export default function useSubmitBatteryConcertDocuments(): UseMutationResult<
  BatteryConcertApplicationStatusDto,
  unknown,
  { proposalId: string }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId }) =>
      batteryProposalService.submitConcertDocumentsForReview(proposalId),
    onSuccess: (status, { proposalId }) => {
      applyBatteryConcertApplicationStatus(queryClient, proposalId, status)
    },
    onError: (_error, { proposalId }) => {
      invalidateBatteryConcertApplication(queryClient, proposalId)
    },
  })
}
